
import BookingCalendar from '../../../components/feature/BookingCalendar';

const TIMESLOTS_API = 'https://readdy.ai/api/public/calendar/timeslots/7da78f1c-1ce6-4a33-946d-e07d4c09be34.b3e608cccb00e5794557ff3aeb30c33d9a1a944de5ae42e75e41b520833b1f71';
const APPOINTMENTS_API = 'https://readdy.ai/api/public/calendar/appointments/7da78f1c-1ce6-4a33-946d-e07d4c09be34.b3e608cccb00e5794557ff3aeb30c33d9a1a944de5ae42e75e41b520833b1f71';

const calendarTexts = {
  stepDate: 'Date',
  stepTime: 'Time',
  stepConfirm: 'Confirm',
  selectDate: 'Select Your Preferred Date',
  selectTime: 'Select Available Time',
  reviewBooking: 'Complete Your Booking',
  selectedDate: 'Date',
  selectedTime: 'Time',
  modifyTime: 'Change Time',
  customerName: 'Full Name',
  customerPhone: 'Phone Number',
  notes: 'Additional Notes',
  notesPlaceholder: 'Any special requests or details we should know?',
  confirmBooking: 'CONFIRM APPOINTMENT',
  booking: 'BOOKING...',
  success: 'Appointment booked successfully! We\'ll contact you shortly to confirm.',
  error: 'Failed to book appointment. Please try again or call us directly.',
  noSlots: 'No available time slots for this date.',
  prev: 'Previous',
  next: 'Continue',
  back: 'Back',
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat'
};

export default function BookAppointment() {
  return (
    <section id="book" className="py-24 bg-neutral-950">
      <div className="max-w-xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-amber-500 text-sm font-bold tracking-wider mb-4">BOOK APPOINTMENT</p>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            RESERVE YOUR SPOT
          </h2>
          <p className="text-stone-400 text-lg">
            Schedule your appointment and experience the Nappy Rootz difference
          </p>
        </div>

        <div className="bg-neutral-900 border border-neutral-800 p-6 md:p-8 rounded-2xl">
          <BookingCalendar
            timeslotsApi={TIMESLOTS_API}
            appointmentsApi={APPOINTMENTS_API}
            texts={calendarTexts}
          />
        </div>
      </div>
    </section>
  );
}
